export default {
    "unexpectedError.title": "Oeps! Er is iets fout gegaan.",
    "unexpectedError.intro": "We zijn een onverwachte fout tegengekomen en kunnen op dit moment niet aan uw verzoek voldoen. We verontschuldigen ons voor het ongemak en stellen uw geduld op prijs. Probeer het volgende:",
    "unexpectedError.refreshPage": "Vernieuw de pagina of probeer het later opnieuw.",
    "unexpectedError.checkConnection": "Controleer uw internetverbinding en browserinstellingen.",
    "unexpectedError.mistake": "Als u denkt dat dit een vergissing is, neem dan contact op met ons support team via onderstaande link.",
    "unexpectedError.thanksForUnderstanding": "Bedankt voor uw begrip.",
    "unexpectedError.contactSupport": "Contacteer Support",
    "unexpectedError.homeButton": "Naar het Overzicht",
 }